<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container bottom-footer">
        <!-- Outer Row -->
        <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <LogoColor formatting="logo-center" width="280px"></LogoColor>
                <div class="card o-hidden border-0 shadow-lg">
                    <div class="card-body p-0">
                        <!-- Nested Row within Card Body -->
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div class="p-5">
                                    <div class="text-center">
                                        <h6 class="text-gray-900">Estamos felizes em ter você com a gente! 💙</h6>
                                        <hr>
                                    </div>
                                    <form class="user" @submit="checkAuthentication">
                                        <div class="form-group">
                                            <label for="">Informe seu CPF / CNPJ</label>
                                            <input type="text" class="form-control form-control-user" id="document"
                                                aria-describedby="documentHelp" placeholder="xxx.xxx.xxx-xx"
                                                v-mask="['###.###.###-##', '##.###.###/####-##']"
                                                v-model="authentication.document">
                                        </div>
                                        <div class="form-group">
                                            <label for="">Informe sua senha</label>
                                            <input type="password" class="form-control form-control-user"
                                                id="exampleInputPassword" placeholder="********"
                                                v-model="authentication.password">
                                        </div>

                                        <button type="submit" :disabled='!isDisabled'
                                            class="btn btn-primary btn-user btn-block">
                                            Acessar <i class="fas fa-sign-in-alt"></i>
                                        </button>
                                    </form>
                                    <hr>
                                    <router-link class="btn btn-link" to="resetPassword">Esqueci minha senha</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import LogoColor from '../img/logo-color.vue';
import axios from 'axios';


export default {
    directives: { mask },
    components: { LogoColor, Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            url_api: '',
            authentication: {
                document: '',
                password: ''
            }
        }
    },
    computed: {
        isDisabled: function () {
            return this.authentication.document != '' && this.authentication.password != '';
        }
    },
    methods: {
        onCancel() { },
        async checkAuthentication(event) {
            event.preventDefault();
            this.isLoading = true;
            try {
                const response = await axios.post(this.url_api + "/auth", this.authentication);
                localStorage.setItem('token', response.data.session.token);
                localStorage.setItem('email', response.data.session.email);
                localStorage.setItem('name', response.data.session.name);
                localStorage.setItem('role', response.data.session.roles[0]);
                localStorage.setItem('expire_in', response.data.session.expire_in);
                localStorage.setItem('change_password', response.data.session.change_password);
                localStorage.setItem('two_authentication_factor', response.data.two_authentication_factor);
                
                this.isLoading = false;
                // if(response.data.session.change_password){
                //     this.$router.push('/change-password-temporary');
                // }else{
                //     this.$router.push('/');
                // }
                
                  this.$router.push('/');
            } catch (err) {
                this.isLoading = false;
                if (err.status == 401) {
                    this.$notify({
                        title: "Falha",
                        text: "Documento e/ou senha inválido(s)!",
                        type: 'error'
                    });
                }else if (err.status == 417) {
                    this.$notify({
                        title: "Falha",
                        text: "Este usuário não pode ter acesso a esta área!",
                        type: 'error'
                    });
                } else {
                    this.$notify({
                        title: "Falha",
                        text: "Sistema indisponível! Tente novamente mais tarde.",
                        type: 'error'
                    });
                }
            }
        }
    },
    mounted() {

        this.isLoading = false;
        this.url_api = process.env.VUE_APP_URL_API

    }
}
</script>

<style>
* {
    scrollbar-width: none;
}

.bottom-footer {
    margin-top: 5%;
    margin-bottom: 400px;
}
</style>